import React from "react";
import CreditManagement from "../CreditManagement";

const AdminTransferHistoryManagement = () => {
    return <CreditManagement managementType="admin" />;
};

export default AdminTransferHistoryManagement;
